<template>
  <div :class="['dashboard', { 'user-dashboard': isUser }]">
    <el-card class="filter-card">
      <div slot="header"><span>数据看板</span></div>
      <el-form :inline="true" :model="queryForm" size="small">
        <el-form-item label="时间">
          <el-button-group>
            <el-button :type="timeType === 'yesterday' ? 'primary' : ''" size="small" @click="setTimeQuick('yesterday')">昨日</el-button>
            <el-button :type="timeType === 'week' ? 'primary' : ''" size="small" @click="setTimeQuick('week')">近7天</el-button>
            <el-button :type="timeType === 'halfMonth' ? 'primary' : ''" size="small" @click="setTimeQuick('halfMonth')">近15天</el-button>
            <el-button :type="timeType === 'month' ? 'primary' : ''" size="small" @click="setTimeQuick('month')">本月</el-button>
            <el-button :type="timeType === 'thirtyDays' ? 'primary' : ''" size="small" @click="setTimeQuick('thirtyDays')">近30天</el-button>
            <el-button size="small" @click="clearTime">全部</el-button>
          </el-button-group>
        </el-form-item>
        <el-form-item label="开始日期">
          <el-date-picker v-model="queryForm.createTimeStart" type="date" placeholder="选择开始日期" value-format="yyyy-MM-dd" style="width:135px"></el-date-picker>
        </el-form-item>
        <el-form-item label="结束日期">
          <el-date-picker v-model="queryForm.createTimeEnd" type="date" placeholder="选择结束日期" value-format="yyyy-MM-dd" style="width:135px"></el-date-picker>
        </el-form-item>
        <el-form-item label="剧场" v-if="isAdmin">
          <el-select v-model="queryForm.theaterName" clearable placeholder="全部" style="width:150px">
            <el-option v-for="t in theaterList" :key="t.id" :label="t.name" :value="t.name"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="视频号ID">
          <el-input v-model="queryForm.videoId" clearable placeholder="视频号ID" style="width:140px"></el-input>
        </el-form-item>
        <el-form-item label="剧目名称">
          <el-input v-model="queryForm.dramaName" clearable placeholder="模糊搜索" style="width:130px"></el-input>
        </el-form-item>
        <el-form-item label="视频号昵称">
          <el-input v-model="queryForm.videoNickname" clearable placeholder="模糊搜索" style="width:130px"></el-input>
        </el-form-item>
        <el-form-item label="挂载">
          <el-select v-model="queryForm.isMounted" clearable placeholder="全部" style="width:80px">
            <el-option label="是" value="是"></el-option>
            <el-option label="否" value="否"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="查询账号" v-if="isAdmin">
          <el-select v-model="queryForm.targetUserId" clearable filterable placeholder="全部账号" style="width:160px">
            <el-option v-for="u in userList" :key="u.id" :label="u.nickname || u.username" :value="u.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleQuery">查询</el-button>
          <el-button @click="handleReset">重置</el-button>
        </el-form-item>
      </el-form>
      <div v-if="queryForm.videoId && videoOwners.length > 0" style="margin-top:6px;color:#606266;font-size:13px">
        <span>所属用户：</span>
        <el-tag v-for="u in videoOwners" :key="u.userId" size="mini" type="success" style="margin-right:4px">{{ u.nickname }}</el-tag>
      </div>
      <div v-else-if="queryForm.videoId && videoOwners.length === 0 && videoOwnersChecked" style="margin-top:6px;color:#c0c4cc;font-size:13px">
        该视频号暂未绑定任何用户
      </div>
    </el-card>

    <el-card v-if="isUser" class="video-bind-card">
      <div slot="header">
        <span>我的视频号</span>
      </div>
      <div>
        <el-tag v-for="(vid, idx) in boundVideoIds" :key="idx" closable size="small"
          style="margin-right:8px;margin-bottom:6px"
          @close="handleUnbind(vid)">
          {{ vid }}
        </el-tag>
        <el-input v-if="addVideoInputVisible" ref="addVideoInput" v-model="newVideoId"
          size="small" placeholder="sph开头"
          style="width:170px;vertical-align:middle"
          @keyup.enter.native="handleAddVideo"
          @blur="handleAddVideo"
          @input="onVideoIdInput"></el-input>
        <el-button v-else size="small" type="primary" plain @click="showAddVideoInput">+ 绑定视频号</el-button>
      </div>
      <div style="font-size:12px;color:#909399;margin-top:4px">只能输入sph开头的视频号ID</div>
      <div v-if="boundVideoIds.length === 0 && !addVideoInputVisible" style="color:#c0c4cc;margin-top:4px">暂无绑定，绑定后可直接查看对应视频号数据</div>
    </el-card>

    <el-row :gutter="12" style="margin-top:12px">
      <el-col :span="Math.floor(24 / summaryCards.length)" v-for="item in summaryCards" :key="item.label">
        <el-card class="summary-card" shadow="hover">
          <div class="summary-label">{{ item.label }}</div>
          <div class="summary-value" :style="{ color: item.color || '#333' }">{{ item.value }}</div>
        </el-card>
      </el-col>
    </el-row>

    <el-card style="margin-top:12px" class="content-card">
      <el-tabs v-model="activeTab" @tab-click="onTabClick">
        <el-tab-pane label="图表" name="chart">
          <div style="height:420px">
            <div ref="chart" style="width:100%;height:420px" v-loading="chartLoading"></div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="数据列表" name="table">
          <div class="table-header">
            <div v-if="isAdmin" class="header-left">
              <el-button type="danger" size="small" :disabled="selectedRows.length === 0" @click="handleBatchDelete">批量删除 ({{ selectedRows.length }})</el-button>
            </div>
            <div class="header-right">
              <el-button type="text" size="small" @click="expandAll">展开全部</el-button>
              <el-button type="text" size="small" @click="collapseAll">折叠全部</el-button>
            </div>
          </div>
          <div v-for="group in groupedData" :key="group.videoId" class="video-group">
            <el-table 
              :data="[group.summary]" 
              :border="false"
              :show-header="false"
              style="width:100%"
            >
              <el-table-column :span="isAdmin ? 14 : 11">
                <template slot-scope="scope">
                  <div class="group-header" @click="toggleExpand(group.videoId)">
                    <div class="group-left">
                      <i 
                        class="expand-icon" 
                        :class="{ expanded: expandedRows.includes(group.videoId) }"
                      ></i>
                      <span class="group-video-id">{{ group.videoId }}</span>
                      <span class="group-video-nickname">{{ group.videoNickname }}</span>
                      <span v-if="group.theaters.length > 0" class="group-theaters">
                        <el-tag v-for="(theater, idx) in group.theaters" :key="idx" size="mini" type="info">
                          {{ theater }}
                        </el-tag>
                      </span>
                      <span class="group-count">({{ group.count }}条)</span>
                    </div>
                    <div class="group-summary">
                      <span class="summary-item">视频播放量: <strong>{{ group.totalVideoPlayCount }}</strong></span>
                      <span class="summary-item">剧集播放量: <strong>{{ group.totalDramaPlayCount }}</strong></span>
                      <span v-if="showTotalIncome" class="summary-item income">总收益: <strong>{{ isUser ? group.totalAfterIncome : group.totalAdIncome }}</strong></span>
                      <span v-if="showAfterIncome" class="summary-item income-success">分成后收益: <strong>{{ group.totalAfterIncome }}</strong></span>
                    </div>
                  </div>
                </template>
              </el-table-column>
            </el-table>
            <div v-show="expandedRows.includes(group.videoId)" class="group-detail" v-loading="lazyLoading[group.videoId]">
              <el-table 
                :data="group.records" 
                :border="false"
                :stripe="isAdmin"
                style="width:100%"
                @selection-change="(val) => handleGroupSelectionChange(val, group.videoId)"
              >
                <el-table-column v-if="isAdmin" type="selection" width="48" align="center"></el-table-column>
                <el-table-column prop="recordDateRange" label="日期范围" width="150" show-overflow-tooltip>
                  <template slot-scope="scope">
                    <span class="table-text">{{ scope.row.recordDateRange }}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="dramaName" label="剧目名称" width="130" show-overflow-tooltip>
                  <template slot-scope="scope">
                    <span class="table-text">{{ scope.row.dramaName }}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="isMounted" label="挂载" width="60" align="center">
                  <template slot-scope="scope">
                    <el-tag :type="scope.row.isMounted === '是' ? 'success' : 'info'" size="mini">{{ scope.row.isMounted || '-' }}</el-tag>
                  </template>
                </el-table-column>
                <el-table-column prop="videoPlayCount" label="视频播放量" width="95" align="right">
                  <template slot-scope="scope">
                    <span class="table-number">{{ toInt(scope.row.videoPlayCount) }}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="dramaPlayCount" label="剧集播放量" width="95" align="right">
                  <template slot-scope="scope">
                    <span class="table-number">{{ toInt(scope.row.dramaPlayCount) }}</span>
                  </template>
                </el-table-column>
                <el-table-column v-if="showTotalIncome" width="115" align="right">
                  <template slot="header">
                    <span>总收益 </span>
                    <el-button 
                      :icon="revenueSort === 'desc' ? 'el-icon-bottom' : revenueSort === 'asc' ? 'el-icon-top' : 'el-icon-sort'"
                      :type="revenueSort ? 'primary' : 'default'"
                      size="mini"
                      circle
                      @click="toggleRevenueSort"
                      title="按总收益排序"
                    ></el-button>
                  </template>
                  <template slot-scope="scope">
                    <span class="table-income">{{ toFixed2(scope.row.adIncome) }}</span>
                  </template>
                </el-table-column>
                <el-table-column v-if="showAfterIncome" label="分成后收益" width="105" align="right">
                  <template slot-scope="scope">
                    <span class="table-income-success">{{ toFixed2(scope.row.afterCommissionIncome != null ? scope.row.afterCommissionIncome : scope.row.adIncome) }}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="theaterName" label="剧场" width="100" show-overflow-tooltip>
                  <template slot-scope="scope">
                    <span class="table-text">{{ scope.row.theaterName }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="导入时间" width="140">
                  <template slot-scope="scope">
                    <span class="table-text">{{ (scope.row.createTime || '').replace('T', ' ') }}</span>
                  </template>
                </el-table-column>
                <el-table-column v-if="isAdmin" label="操作" width="70" align="center">
                  <template slot-scope="scope">
                    <el-button type="text" size="small" class="delete-btn" @click="handleDelete(scope.row)">删除</el-button>
                  </template>
                </el-table-column>
              </el-table>
              <div v-if="getGroupTotal(group.videoId) > 10" class="group-pagination">
                <el-pagination
                  background
                  layout="total, prev, pager, next, sizes"
                  :total="getGroupTotal(group.videoId)"
                  :page-size="getGroupPageSize(group.videoId)"
                  :current-page="getGroupCurrentPage(group.videoId)"
                  :page-sizes="[10, 20, 50]"
                  @current-change="(v) => setGroupCurrentPage(group.videoId, v)"
                  @size-change="(v) => setGroupPageSize(group.videoId, v)"
                >
                </el-pagination>
              </div>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </el-card>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import api from '@/api'
import * as echarts from 'echarts'

function formatDate(d) {
  const y = d.getFullYear()
  const m = String(d.getMonth() + 1).padStart(2, '0')
  const day = String(d.getDate()).padStart(2, '0')
  return y + '-' + m + '-' + day
}
function getYesterday() {
  const d = new Date(); d.setDate(d.getDate() - 1)
  return { start: formatDate(d), end: formatDate(d) }
}
function getLastDays(n) {
  const end = new Date()
  const start = new Date(); start.setDate(start.getDate() - n + 1)
  return { start: formatDate(start), end: formatDate(end) }
}
function getThisMonth() {
  const now = new Date()
  return { start: formatDate(new Date(now.getFullYear(), now.getMonth(), 1)), end: formatDate(now) }
}
function toFixed2(val) {
  if (val == null || val === '') return '0.00'
  const n = parseFloat(val)
  if (isNaN(n)) return '0.00'
  return n.toFixed(2)
}
function toInt(val) {
  if (val == null || val === '') return '0'
  const n = parseFloat(val)
  if (isNaN(n)) return '0'
  return String(Math.floor(n))
}

export default {
  name: 'Dashboard',
  data() {
    return {
      activeTab: 'chart',
      timeType: '',
      queryForm: { videoId: '', dramaName: '', dramaId: '', videoNickname: '', isMounted: '是', theaterName: '', createTimeStart: '', createTimeEnd: '', targetUserId: null, pageNum: 1, pageSize: 10 },
      summaryCards: [
        { label: '视频播放量', value: '0', key: 'videoPlayCount' },
        { label: '剧集播放量', value: '0', key: 'dramaPlayCount' },
        { label: '总收益', value: '0', key: 'adIncome' },
        { label: '分成后收益', value: '0', key: 'afterIncome', color: '#67c23a' },
        { label: '数据条数', value: '0', key: 'count' }
      ],
      selectedRows: [],
      chartLoading: false,
      chartInstance: null,
      theaterList: [],
      addVideoInputVisible: false,
      newVideoId: '',
      sortField: '',
      sortOrder: '',
      queryDebounceTimer: null,
      groupStats: [],
      revenueSort: '', // 总收益排序: '' / 'asc' / 'desc'
      lazyRecords: {},
      lazyLoading: {},
      videoOwners: [],
      videoOwnersChecked: false,
      expandedRows: [],
      groupPageSizes: {},
      groupCurrentPages: {},
      groupTotals: {},
      groupRequestIds: {},
      userList: []
    }
  },
  mounted() {
    this.loadSummaryCards()
    this.handleQuery()
    api.theaterList().then(res => { this.theaterList = res.data || [] })
    this.loadUserList()
  },
  watch: {
    'queryForm.videoId'(val) {
      this.videoOwners = []
      this.videoOwnersChecked = false
      if (val && val.trim()) {
        api.getVideoOwners(val.trim()).then(res => {
          this.videoOwners = res.data || []
          this.videoOwnersChecked = true
        }).catch(() => {
          this.videoOwnersChecked = true
        })
      }
    }
  },
  computed: {
    ...mapState(['userInfo']),
    ...mapGetters(['isSuperAdmin', 'isSubAdmin', 'isUser']),
    isAdmin() { return this.isSuperAdmin || this.isSubAdmin },
    showTotalIncome() {
      const perm = this.userInfo.incomePermission || 'BOTH'
      return perm === 'BOTH' || perm === 'ONLY_TOTAL'
    },
    showAfterIncome() {
      if (this.isUser) return false
      const perm = this.userInfo.incomePermission || 'BOTH'
      return perm === 'BOTH' || perm === 'ONLY_AFTER'
    },
    boundVideoIds() {
      return (this.userInfo && this.userInfo.boundVideoIds) || []
    },
    groupedData() {
      return this.groupStats.map(group => {
        return {
        videoId: group.videoId,
        videoNickname: group.videoNickname,
        theaters: group.theaters || [],
        count: group.count,
        totalVideoPlayCount: Math.floor(parseFloat(group.totalVideoPlayCount || 0)),
        totalDramaPlayCount: Math.floor(parseFloat(group.totalDramaPlayCount || 0)),
        totalAdIncome: Number(group.totalAdIncome || 0).toFixed(2),
        totalAfterIncome: Number(group.totalAfterIncome || 0).toFixed(2),
        records: this.lazyRecords[group.videoId] || [],
        summary: {}
      }})
    }
  },
  methods: {
    toFixed2,
    toInt,
    toggleRevenueSort() {
      // 循环切换: '' → 'desc' → 'asc' → ''
      if (!this.revenueSort) {
        this.revenueSort = 'desc'
      } else if (this.revenueSort === 'desc') {
        this.revenueSort = 'asc'
      } else {
        this.revenueSort = ''
      }
      this.expandedRows.forEach(videoId => {
        this.$set(this.groupCurrentPages, videoId, 1)
        this.loadGroupRecords(videoId)
      })
    },
    loadUserList() {
      if (this.isSuperAdmin) {
        api.getAllUsers().then(res => { this.userList = res.data || [] })
      } else if (this.isSubAdmin) {
        api.getSubUsers().then(res => { this.userList = res.data || [] })
      }
    },
    loadSummaryCards() {
      const cards = [
        { label: '视频播放量', value: '0', key: 'videoPlayCount' },
        { label: '剧集播放量', value: '0', key: 'dramaPlayCount' }
      ]
      if (this.showTotalIncome) {
        cards.push({ label: '总收益', value: '0', key: 'adIncome' })
      }
      if (this.showAfterIncome) {
        cards.push({ label: '分成后收益', value: '0', key: 'afterIncome', color: '#67c23a' })
      }
      cards.push({ label: '数据条数', value: '0', key: 'count' })
      this.summaryCards = cards
    },
    setTimeQuick(type) {
      this.timeType = type
      let range
      switch (type) {
        case 'yesterday': range = getYesterday(); break
        case 'week': range = getLastDays(7); break
        case 'halfMonth': range = getLastDays(15); break
        case 'month': range = getThisMonth(); break
        case 'thirtyDays': range = getLastDays(30); break
      }
      this.queryForm.createTimeStart = range.start
      this.queryForm.createTimeEnd = range.end
      this.queryForm.pageNum = 1
    },
    onDateChange() {
      this.timeType = ''
      this.queryForm.pageNum = 1
    },
    clearTime() {
      this.timeType = ''
      this.queryForm.createTimeStart = ''
      this.queryForm.createTimeEnd = ''
      this.queryForm.pageNum = 1
    },
    handleReset() {
      this.timeType = ''
      this.queryForm = { videoId: '', dramaName: '', dramaId: '', videoNickname: '', isMounted: '是', theaterName: '', createTimeStart: '', createTimeEnd: '', targetUserId: null, pageNum: 1, pageSize: 10 }
      this.loadSummaryCards()
      this.handleQuery()
    },
    onTabClick(tab) {
      if (tab.name === 'chart') {
        this.$nextTick(() => {
          if (!this.chartInstance) {
            this.renderChart()
          } else {
            this.chartInstance.resize()
          }
        })
      }
    },
    handleQuery() {
      if (this.queryDebounceTimer) {
        clearTimeout(this.queryDebounceTimer)
      }
      this.queryDebounceTimer = setTimeout(() => {
        this.doQuery()
      }, 300)
    },
    doQuery() {
      this.resetGroupPagination()
      this.lazyRecords = {}
      this.expandedRows.forEach(videoId => {
        this.loadGroupRecords(videoId)
      })
      const params = { ...this.queryForm }
      if (this.sortField) {
        params.sortField = this.sortField
        params.sortOrder = this.sortOrder
      }

      // 首页默认只加载汇总和分组统计，明细列表等展开分组时再请求
      this.summaryCards = this.summaryCards.map(card => ({
        ...card,
        value: '查询中'
      }))
      api.getSummaryStats(params).then(res => {
        this.calcSummary(res.data || {})
      }).catch(err => {
        console.error('汇总查询失败:', err)
        this.calcSummary({})
      })

      this.chartLoading = true
      api.getGroupStats(params).then(res => {
        this.groupStats = res.data || []
        this.renderChart()
      }).catch(err => {
        console.error('分组查询失败:', err)
      }).finally(() => {
        this.chartLoading = false
      })
    },
    calcSummary(summaryData) {
      const videoPlayCount = (summaryData.videoPlayCount != null) ? String(Math.floor(parseFloat(summaryData.videoPlayCount))) : '0'
      const dramaPlayCount = (summaryData.dramaPlayCount != null) ? String(Math.floor(parseFloat(summaryData.dramaPlayCount))) : '0'
      const adIncome = (summaryData.adIncome != null) ? Number(summaryData.adIncome).toFixed(2) : '0.00'
      const afterIncome = (summaryData.afterIncome != null) ? Number(summaryData.afterIncome).toFixed(2) : '0.00'
      const count = (summaryData.count != null) ? String(summaryData.count) : '0'

      const cards = [
        { label: '视频播放量', value: videoPlayCount, key: 'videoPlayCount' },
        { label: '剧集播放量', value: dramaPlayCount, key: 'dramaPlayCount' }
      ]
      if (this.showTotalIncome) {
        cards.push({ label: '总收益', value: adIncome, key: 'adIncome' })
      }
      if (this.showAfterIncome) {
        cards.push({ label: '分成后收益', value: afterIncome, key: 'afterIncome', color: '#67c23a' })
      }
      cards.push({ label: '数据条数', value: count, key: 'count' })
      this.summaryCards = cards
    },
    renderChart() {
      if (!this.$refs.chart) return
      if (!this.chartInstance) {
        this.chartInstance = echarts.init(this.$refs.chart)
      }
      const groups = this.groupStats
      if (!groups || groups.length === 0) {
        this.chartInstance.setOption({
          title: { text: '暂无数据', left: 'center', top: 'center' }
        })
        return
      }
      const sortKey = this.isUser ? 'totalAfterIncome' : 'totalAdIncome'
      const entries = [...groups]
        .sort((a, b) => parseFloat(b[sortKey] || 0) - parseFloat(a[sortKey] || 0))
        .slice(0, 20)
      const names = entries.map(e => e.videoNickname || e.videoId)
      const legendData = []
      const series = []
      if (this.showTotalIncome) {
        legendData.push('总收益')
        series.push({
          name: '总收益',
          type: 'bar',
          data: entries.map(e => Number(parseFloat(this.isUser ? e.totalAfterIncome : e.totalAdIncome || 0).toFixed(2)))
        })
      }
      if (this.showAfterIncome) {
        legendData.push('分成后收益')
        series.push({
          name: '分成后收益',
          type: 'bar',
          data: entries.map(e => Number(parseFloat(e.totalAfterIncome || 0).toFixed(2)))
        })
      }
      this.chartInstance.setOption({
        tooltip: { trigger: 'axis' },
        legend: { data: legendData },
        grid: { left: '3%', right: '4%', bottom: '15%', containLabel: true },
        xAxis: { type: 'category', data: names, axisLabel: { rotate: 45, fontSize: 10 } },
        yAxis: { type: 'value' },
        series: series
      })
    },
    showAddVideoInput() {
      this.addVideoInputVisible = true
      this.$nextTick(() => { this.$refs.addVideoInput && this.$refs.addVideoInput.focus() })
    },
    onVideoIdInput(val) {
      // 只允许字母数字和常用符号，过滤汉字
      this.newVideoId = val.replace(/[^a-zA-Z0-9_\-]/g, '')
    },
    handleAddVideo() {
      const val = this.newVideoId.trim()
      if (!val) { this.addVideoInputVisible = false; return }
      if (!val.startsWith('sph')) {
        this.$message.warning('视频号ID必须以sph开头')
        this.newVideoId = ''
        return
      }
      api.bindVideo({ videoId: val }).then(() => {
        this.$message.success('绑定成功')
        this.newVideoId = ''
        this.addVideoInputVisible = false
        api.getUserInfo().then(res => {
          const info = res.data
          this.$store.commit('SET_USER_INFO', {
            userId: info.id, username: info.username, nickname: info.nickname,
            roleType: info.roleType, canImport: info.canImport,
            incomePermission: info.incomePermission || 'BOTH',
            boundVideoIds: info.boundVideoIds || []
          })
        })
      })
    },
    handleUnbind(videoId) {
      this.$confirm('确认解绑视频号 "' + videoId + '" ?', '提示', { type: 'warning' }).then(() => {
        api.unbindVideo(videoId).then(() => {
          this.$message.success('已解绑')
          api.getUserInfo().then(res => {
            const info = res.data
            this.$store.commit('SET_USER_INFO', {
              userId: info.id, username: info.username, nickname: info.nickname,
              roleType: info.roleType, canImport: info.canImport,
              incomePermission: info.incomePermission || 'BOTH',
              boundVideoIds: info.boundVideoIds || []
            })
          })
        })
      }).catch(() => {})
    },
    handleSelectionChange(val) {
      this.selectedRows = val
    },
    handleSortChange({ prop, order }) {
      this.sortField = prop
      this.sortOrder = order || ''
      this.queryForm.pageNum = 1
      this.handleQuery()
    },
    handleDelete(row) {
      this.$confirm('确认删除该条数据吗？', '提示', { type: 'warning' }).then(() => {
        api.deleteDataRecord(row.id).then(() => {
          this.$message.success('删除成功')
          this.handleQuery()
        })
      }).catch(() => {})
    },
    toggleExpand(videoId) {
      const index = this.expandedRows.indexOf(videoId)
      if (index > -1) {
        this.expandedRows.splice(index, 1)
      } else {
        this.expandedRows.push(videoId)
        this.loadGroupRecords(videoId)
      }
    },
    expandAll() {
      this.expandedRows = this.groupStats.map(g => g.videoId).filter(v => v)
      this.groupStats.forEach(g => {
        if (g.videoId) this.loadGroupRecords(g.videoId)
      })
    },
    collapseAll() {
      this.expandedRows = []
    },
    getGroupPageSize(videoId) {
      return this.groupPageSizes[videoId] || 10
    },
    setGroupPageSize(videoId, size) {
      this.$set(this.groupPageSizes, videoId, size)
      this.$set(this.groupCurrentPages, videoId, 1)
      this.loadGroupRecords(videoId)
    },
    getGroupCurrentPage(videoId) {
      return this.groupCurrentPages[videoId] || 1
    },
    setGroupCurrentPage(videoId, page) {
      this.$set(this.groupCurrentPages, videoId, page)
      this.loadGroupRecords(videoId)
    },
    getGroupTotal(videoId) {
      if (this.groupTotals[videoId] != null) return this.groupTotals[videoId]
      const group = this.groupStats.find(item => item.videoId === videoId)
      return group ? (group.count || 0) : 0
    },
    loadGroupRecords(videoId) {
      if (!videoId) return
      const requestId = (this.groupRequestIds[videoId] || 0) + 1
      this.$set(this.groupRequestIds, videoId, requestId)
      this.$set(this.lazyLoading, videoId, true)
      const pageNum = this.getGroupCurrentPage(videoId)
      const pageSize = this.getGroupPageSize(videoId)
      const filter = { ...this.queryForm, videoId, pageNum, pageSize }
      if (this.revenueSort) {
        filter.sortField = 'adIncome'
        filter.sortOrder = this.revenueSort === 'asc' ? 'ascending' : 'descending'
      } else if (this.sortField) {
        filter.sortField = this.sortField
        filter.sortOrder = this.sortOrder
      }
      api.queryData(filter).then(res => {
        if (this.groupRequestIds[videoId] !== requestId) return
        const pageData = res.data || {}
        this.$set(this.lazyRecords, videoId, pageData.records || [])
        this.$set(this.groupTotals, videoId, pageData.total || 0)
      }).finally(() => {
        if (this.groupRequestIds[videoId] === requestId) {
          this.$set(this.lazyLoading, videoId, false)
        }
      })
    },
    resetGroupPagination() {
      this.groupPageSizes = {}
      this.groupCurrentPages = {}
      this.groupTotals = {}
      this.groupRequestIds = {}
    },
    handleGroupSelectionChange(val, videoId) {
      const existingIds = this.selectedRows.map(r => r.id)
      val.forEach(row => {
        if (!existingIds.includes(row.id)) {
          this.selectedRows.push(row)
        }
      })
      this.selectedRows = this.selectedRows.filter(r => {
        const stillSelected = val.some(v => v.id === r.id)
        if (!stillSelected && r.videoId === videoId) {
          return false
        }
        return true
      })
    },
    handleBatchDelete() {
      if (this.selectedRows.length === 0) {
        this.$message.warning('请先选择要删除的数据')
        return
      }
      this.$confirm('确认删除选中的 ' + this.selectedRows.length + ' 条数据吗？', '提示', { type: 'warning' }).then(() => {
        const ids = this.selectedRows.map(row => row.id)
        api.deleteDataRecordBatch(ids).then(() => {
          this.$message.success('批量删除成功')
          this.selectedRows = []
          this.handleQuery()
        })
      }).catch(() => {})
    }
  },
  beforeDestroy() {
    if (this.chartInstance) { this.chartInstance.dispose() }
  }
}
</script>

<style scoped>
.dashboard {
  min-height: 100%;
  background: #f5f7fa;
  padding: 16px;
}

.filter-card {
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  margin-bottom: 16px;
  transition: all 0.3s ease;
}

.filter-card:hover {
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
}

.filter-card >>> .el-card__body { 
  padding: 16px 24px; 
}

.video-bind-card {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 8px;
  box-shadow: 0 4px 16px rgba(102, 126, 234, 0.3);
  margin-bottom: 16px;
  border: none;
}

.video-bind-card >>> .el-card__header {
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.video-bind-card >>> .el-card__header span {
  color: #fff;
  font-weight: 600;
}

.video-bind-card >>> .el-card__body { 
  padding: 16px 24px; 
}

.video-bind-card >>> .el-tag {
  background: rgba(255, 255, 255, 0.2);
  border: none;
  color: #fff;
}

.video-bind-card >>> .el-tag .el-tag__close {
  color: rgba(255, 255, 255, 0.7);
}

.video-bind-card >>> .el-input__inner {
  background: rgba(255, 255, 255, 0.15);
  border: 1px solid rgba(255, 255, 255, 0.3);
  color: #fff;
}

.video-bind-card >>> .el-input__placeholder {
  color: rgba(255, 255, 255, 0.6);
}

.video-bind-card >>> .el-button--primary {
  background: rgba(255, 255, 255, 0.2);
  border-color: rgba(255, 255, 255, 0.4);
  color: #fff;
}

.video-bind-card >>> .el-button--primary:hover {
  background: rgba(255, 255, 255, 0.3);
}

.summary-card {
  text-align: center;
  cursor: default;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
}

.summary-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 4px;
  height: 100%;
  background: linear-gradient(180deg, #667eea 0%, #764ba2 100%);
}

.summary-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
}

.summary-card >>> .el-card__body { 
  padding: 20px 16px; 
}

.summary-label { 
  font-size: 13px; 
  color: #8a8f99; 
  margin-bottom: 8px; 
  font-weight: 500;
}

.summary-value { 
  font-size: 28px; 
  font-weight: 700;
  color: #1f2937;
  letter-spacing: -0.5px;
}

.content-card {
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  margin-top: 16px;
}

.content-card >>> .el-card__body { 
  padding: 20px 24px; 
}

.content-card >>> .el-tabs__header {
  margin-bottom: 16px;
}

.content-card >>> .el-tabs__nav-wrap::after {
  background: #e5e7eb;
}

.content-card >>> .el-tabs__item {
  font-weight: 500;
  color: #6b7280;
}

.content-card >>> .el-tabs__item.is-active {
  color: #667eea;
}

.content-card >>> .el-tabs__active-bar {
  background: linear-gradient(90deg, #667eea 0%, #764ba2 100%);
}

.content-card >>> .el-table {
  border-radius: 8px;
  overflow: hidden;
}

.content-card >>> .el-table thead {
  background: #f9fafb;
}

.content-card >>> .el-table thead th {
  color: #4b5563;
  font-weight: 600;
  font-size: 13px;
  padding: 12px 0;
}

.content-card >>> .el-table__body tr:hover > td {
  background: #f3f4f6;
}

.content-card >>> .el-table__body tr.current-row > td {
  background: #eef2ff;
}

.content-card >>> .el-pagination {
  margin-top: 16px;
}

.content-card >>> .el-pagination.is-background .el-pager li:not(.disabled):hover {
  color: #667eea;
}

.content-card >>> .el-pagination.is-background .el-pager li.active {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
}

.content-card >>> .el-tag--success {
  background: #d1fae5;
  color: #065f46;
  border: none;
}

.content-card >>> .el-tag--info {
  background: #dbeafe;
  color: #1e40af;
  border: none;
}

.content-card >>> .el-tag--warning {
  background: #fef3c7;
  color: #d97706;
  border: none;
}

.content-card >>> .el-button--danger {
  color: #ef4444;
}

.content-card >>> .el-button--danger:hover {
  background: #fef2f2;
}

.content-card >>> .el-button--primary {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border: none;
}

.content-card >>> .el-button--primary:hover {
  opacity: 0.9;
}

.el-form-item {
  margin-bottom: 12px;
}

.el-button-group .el-button {
  border-radius: 4px;
  margin-right: 4px;
}

.el-button-group .el-button:last-child {
  margin-right: 0;
}

/* 用户角色表格样式 */
.table-text {
  color: #374151;
  font-size: 13px;
}

.table-number {
  color: #4b5563;
  font-size: 13px;
  font-weight: 500;
}

.table-income {
  color: #1f2937;
  font-size: 13px;
  font-weight: 600;
}

.table-income-success {
  color: #10b981;
  font-size: 13px;
  font-weight: 600;
}

.table-empty {
  color: #9ca3af;
  font-size: 12px;
}

.delete-btn {
  color: #ef4444 !important;
  font-size: 12px;
}

.delete-btn:hover {
  background: #fef2f2;
}

/* 表格头部 */
.table-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}

/* 视频号分组 */
.video-group {
  margin-bottom: 12px;
  border-radius: 8px;
  overflow: hidden;
  background: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}

.group-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 14px 20px;
  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
  cursor: pointer;
  transition: all 0.2s ease;
}

.group-header:hover {
  background: linear-gradient(135deg, #f1f5f9 0%, #e2e8f0 100%);
}

.group-left {
  display: flex;
  align-items: center;
  gap: 12px;
}

.group-video-id {
  font-size: 14px;
  font-weight: 600;
  color: #1e293b;
}

.group-video-nickname {
  font-size: 13px;
  color: #64748b;
  padding: 2px 8px;
  background: #dbeafe;
  border-radius: 4px;
}

.group-theaters {
  display: flex;
  gap: 6px;
}

.group-theaters .el-tag {
  background: rgba(148, 163, 184, 0.15);
  border-color: rgba(148, 163, 184, 0.3);
  color: #475569;
}

.group-count {
  font-size: 12px;
  color: #9ca3af;
}

.group-summary {
  display: flex;
  gap: 20px;
}

.summary-item {
  font-size: 13px;
  color: #475569;
}

.summary-item strong {
  color: #1e293b;
  font-weight: 600;
}

.summary-item.income strong {
  color: #3b82f6;
}

.summary-item.income-success strong {
  color: #10b981;
}

.group-detail {
  border-top: 1px solid #e2e8f0;
}

.group-detail .el-table {
  margin: 0;
}

.group-detail .el-table thead {
  background: #fafafa;
}

.group-detail .el-table thead th {
  padding: 10px 8px;
  font-size: 12px;
  color: #64748b;
  font-weight: 500;
}

.group-detail .el-table__body tr {
  border-bottom: 1px solid #f1f5f9;
}

.group-detail .el-table__body tr:last-child {
  border-bottom: none;
}

.group-detail .el-table__body tr:hover > td {
  background: #f8fafc;
}

.group-pagination {
  padding: 12px 20px;
  background: #fafafa;
  border-top: 1px solid #e2e8f0;
  display: flex;
  justify-content: flex-end;
}

.group-pagination .el-pagination {
  margin: 0;
}

.group-pagination .el-pagination.is-background .el-pager li.active {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
}

.group-pagination .el-pagination.is-background .el-pager li:not(.disabled):hover {
  color: #667eea;
}

/* 用户角色分组样式 */
.user-dashboard .video-group {
  background: rgba(255, 255, 255, 0.95);
}

.user-dashboard .group-header {
  background: linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%);
}

.user-dashboard .group-header:hover {
  background: linear-gradient(135deg, #dbeafe 0%, #bfdbfe 100%);
}

.user-dashboard .group-video-id {
  color: #1e40af;
}

.user-dashboard .group-video-nickname {
  background: rgba(99, 102, 241, 0.15);
  color: #6366f1;
}

.user-dashboard .summary-item.income strong {
  color: #6366f1;
}

.header-left {
  display: flex;
  gap: 8px;
}

.header-right {
  display: flex;
  gap: 12px;
}

.header-right .el-button--text {
  color: #667eea;
  font-size: 13px;
}

.header-right .el-button--text:hover {
  color: #5a6fd6;
  background: rgba(102, 126, 234, 0.1);
}

/* 展开图标 */
.expand-icon {
  display: inline-block;
  width: 20px;
  height: 20px;
  cursor: pointer;
  position: relative;
  transition: transform 0.2s ease;
}

.expand-icon::before,
.expand-icon::after {
  content: '';
  position: absolute;
  background: #6b7280;
  transition: all 0.2s ease;
}

.expand-icon::before {
  width: 12px;
  height: 2px;
  top: 9px;
  left: 4px;
}

.expand-icon::after {
  width: 2px;
  height: 12px;
  top: 4px;
  left: 9px;
}

.expand-icon.expanded::after {
  opacity: 0;
}

.expand-icon:hover::before,
.expand-icon:hover::after {
  background: #667eea;
}

/* 详情面板 */
.detail-panel {
  padding: 16px 24px;
  background: #fafafa;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px;
}

.detail-row {
  display: flex;
  align-items: center;
  gap: 8px;
}

.detail-label {
  font-size: 13px;
  color: #6b7280;
  font-weight: 500;
  min-width: 80px;
}

.detail-value {
  font-size: 13px;
  color: #374151;
  word-break: break-all;
  flex: 1;
}

/* 用户角色详情面板 */
.user-dashboard .detail-panel {
  background: #f0f5ff;
}

.user-dashboard .detail-row {
  gap: 6px;
}

.user-dashboard .detail-label {
  color: #6366f1;
}

.user-dashboard .detail-value {
  color: #1e293b;
}

/* 用户角色专属样式 */
.user-dashboard {
  background: linear-gradient(180deg, #f0f5ff 0%, #f5f7fa 100%);
}

.user-dashboard .filter-card {
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(10px);
}

.user-dashboard .summary-card {
  background: rgba(255, 255, 255, 0.95);
}

.user-dashboard .content-card {
  background: rgba(255, 255, 255, 0.95);
}

.user-dashboard .content-card >>> .el-table {
  border-radius: 12px;
  border: 1px solid #e5e7eb;
}

.user-dashboard .content-card >>> .el-table thead {
  background: linear-gradient(180deg, #f8fafc 0%, #f1f5f9 100%);
}

.user-dashboard .content-card >>> .el-table thead th {
  border-bottom: 2px solid #e2e8f0;
}

.user-dashboard .content-card >>> .el-table__body tr {
  border-bottom: 1px solid #f1f5f9;
}

.user-dashboard .content-card >>> .el-table__body tr:last-child {
  border-bottom: none;
}

.user-dashboard .content-card >>> .el-table__body tr:hover > td {
  background: #eff6ff;
}

.user-dashboard .content-card >>> .el-table__body tr.current-row > td {
  background: #dbeafe;
}

.el-form-item {
  margin-bottom: 12px;
}

.el-button-group .el-button {
  border-radius: 4px;
  margin-right: 4px;
}

.el-button-group .el-button:last-child {
  margin-right: 0;
}
</style>
